"use strict";
/**
 * Firestore v9/v10 wrapper.  The programming model for the "Web" and "Admin" Firebase SDKs
 * has diverged quite a bit, so this unifying API is pretty complex and covers a lot of the
 * Firebase API surface.
 *
 * WARNING: Because the FirebaseV9-AdminImpl is blanked out in the web build, don't use the
 * Admin types directly here (e.g., for disambiguating).  Always use the Web types.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirebaseConnection = exports.FieldPlaceholder = void 0;
exports.testUserName = testUserName;
exports.testUserAuth = testUserAuth;
exports.usingEmulator = usingEmulator;
exports.getFirebaseEnv = getFirebaseEnv;
exports.connectAdmin = connectAdmin;
exports.connectWeb = connectWeb;
exports.transaction = transaction;
exports.writeBatch = writeBatch;
exports.shouldRetry = shouldRetry;
exports.firestoreRetryOnErr = firestoreRetryOnErr;
const FirebaseV9_CommonImpl_1 = require("./FirebaseV9-CommonImpl");
Object.defineProperty(exports, "FieldPlaceholder", { enumerable: true, get: function () { return FirebaseV9_CommonImpl_1.FieldPlaceholder; } });
const FirebaseV9_AdminImpl_1 = require("./FirebaseV9-AdminImpl"); // zeroed out in browser packaging
const FirebaseV9_WebImpl_1 = require("./FirebaseV9-WebImpl");
const Retry = require("./Retry");
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseWebConfig = {
    apiKey: 'AIzaSyCInvOm2V0TJeht-sAuEBWkPRQp7ZGRrFI',
    authDomain: 'numbets-92cc6.firebaseapp.com',
    projectId: 'numbets-92cc6',
    storageBucket: 'numbets-92cc6.appspot.com',
    messagingSenderId: '460440256167',
    appId: '1:460440256167:web:eac0a6a98819ef793a6582',
    measurementId: 'G-7VTGT3Q06G'
};
function testUserName(testAcctNum) {
    return `robotuser0${testAcctNum + 1}@bitiotic.com`;
}
/**
 * For testing only.  Return the username (email) and password for the given test user number.
 * @param testAcct {string|number} small positive number
 */
function testUserAuth(testAcct) {
    if (typeof testAcct === 'string') {
        return {
            username: `${testAcct}@testUser.bitiotic.com`,
            password: `Fr33formTe$ter-${testAcct}`,
        };
    }
    return {
        username: testUserName(testAcct),
        password: `Fr33formTe$ter0${testAcct + 1}`,
    };
}
// export FIRESTORE_EMULATOR_HOST="cerberus:8580"
// export FIREBASE_AUTH_EMULATOR_HOST="cerberus:8599"
const emulatorConfig = {
    useEmulator: true,
    storeEmulator: {
        host: 'cerberus',
        port: 8580,
    },
    authEmulator: {
        host: 'cerberus',
        port: 8599,
    },
    funcEmulator: {
        host: 'cerberus',
        port: 8593,
    }
};
// Check that the right version of node is being used (if we're running on node).
function versionCheck() {
    if (typeof process === 'object') {
        if (typeof process.versions === 'object') {
            if (typeof process.versions.node !== 'undefined') {
                const [_prefix, verstr] = process.version.split('v');
                if (verstr) {
                    const major = verstr.split('.')[0];
                    if (major) {
                        if (parseInt(major, 10) >= 18) {
                            return;
                        }
                    }
                }
                throw new Error(`Too-old node version: ${process.version}`);
            }
        }
    }
    //const raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./u);
    //const rawEl = raw && raw[2];
    //const browserVersion = rawEl ? parseInt(rawEl, 10) : false;
}
versionCheck();
/**
 * Detect if Firebase Emulator should be attached to, or if we're in production.
 */
function usingEmulator(ctx) {
    const useEmu = (process.env.FUNCTIONS_EMULATOR === 'true');
    const emuStr = useEmu ? 'emulator' : 'Firestore';
    if (process.env.NODE_ENV !== 'production') {
        ctx.log('Build: debug,', emuStr);
    }
    else {
        ctx.log('Build: prod,', emuStr);
    }
    return useEmu;
}
;
/**
 * Get emulator config, if necessary, from environment.  Fallback on hard-coded default.
 */
function getEmulatorConfig(ctx, useEmulator) {
    const cfg = { ...emulatorConfig, useEmulator };
    if (useEmulator) {
        ctx.log('Using Firestore Emulator, initial config:', cfg);
        if (typeof process === 'object' && typeof process.env === 'object') {
            splitEnv(process.env.FIRESTORE_EMULATOR_HOST, cfg.storeEmulator);
            splitEnv(process.env.FIREBASE_AUTH_EMULATOR_HOST, cfg.authEmulator);
            splitEnv(process.env.FIREBASE_FUNC_EMULATOR_HOST, cfg.funcEmulator);
            ctx.log('Using Firestore Emulator, env-based config:', cfg);
        }
    }
    return cfg;
    function splitEnv(s, cfg) {
        if (typeof s === 'string') {
            const [host, port] = s.split(':'); // "cerberus:8599"
            if (host && port) {
                cfg.host = host;
                cfg.port = parseInt(port, 10);
            }
        }
    }
}
let fbEnv = 'none';
function getFirebaseEnv() {
    const e = fbEnv;
    if (e === 'none') {
        throw new Error('Uninitialized env');
    }
    return e;
}
/**
 * Connect to Firebase and Firestore using firebase-admin SDK.
 */
function connectAdmin(ctx, serviceAccount, funcs, useEmulator) {
    ctx.assertEqual(fbEnv, 'none');
    fbEnv = 'ADMIN';
    // Try to avoid logging the private key ..
    const logAcct = (serviceAccount === null) ? '<null>' : serviceAccount['client_email'];
    ctx.log(`connectAdmin(svcAccts: "${logAcct}", useEmulator: ${useEmulator})`);
    return (0, FirebaseV9_AdminImpl_1.firebaseConnectAdminFirestore)(ctx, firebaseWebConfig.projectId, serviceAccount, funcs, getEmulatorConfig(ctx, useEmulator));
}
/**
 * Connect to Firebase and Firestore using firebase Web SDK.
 */
function connectWeb(ctx, useEmulator) {
    ctx.assertEqual(fbEnv, 'none');
    fbEnv = 'WEB';
    ctx.log(`connectWeb(useEmulator:${useEmulator})`);
    return (0, FirebaseV9_WebImpl_1.firebaseConnectWebFirestore)(ctx, firebaseWebConfig, getEmulatorConfig(ctx, useEmulator));
}
/**
 * Agnostic wrapper for Firestore transactions.  See {@link firestoreTransaction}.
 */
class FirestoreTxWrapper {
    constructor(realTx) {
        if (realTx instanceof FirebaseV9_WebImpl_1.FirestoreWebTX) {
            this.webTx = realTx;
        }
        else {
            this.adminTx = realTx;
        }
    }
    getDoc(ctx, docRef) {
        if (this.webTx) {
            return this.webTx.getDoc(ctx, docRef);
        }
        else if (this.adminTx) {
            return this.adminTx.getDoc(ctx, docRef);
        }
        throw ctx.newError('Invalid TX');
    }
    setDoc(ctx, docRef, data) {
        if (this.webTx) {
            this.webTx.setDoc(ctx, docRef, data);
        }
        else if (this.adminTx) {
            this.adminTx.setDoc(ctx, docRef, data);
        }
        else {
            throw ctx.newError('Invalid TX');
        }
    }
    patchIn(ctx, docRef, data) {
        if (this.webTx) {
            this.webTx.patchIn(ctx, docRef, data);
        }
        else if (this.adminTx) {
            this.adminTx.patchIn(ctx, docRef, data);
        }
        else {
            throw ctx.newError('Invalid TX');
        }
    }
}
function transaction(ctx, fs, cb) {
    return fs._runInTransaction(ctx, tx => {
        const txWrapper = new FirestoreTxWrapper(tx);
        return cb(txWrapper);
    });
}
/**
 * Agnostic wrapper for batched Firestore writes.
 */
class FirestoreBatch {
    constructor(batch) {
        if (batch instanceof FirebaseV9_WebImpl_1.FirestoreWebBatch) {
            this.webBatch = batch;
        }
        else {
            this.adminBatch = batch;
        }
    }
    setDoc(ctx, docRef, data) {
        if (this.webBatch) {
            this.webBatch.setDoc(ctx, docRef, data);
        }
        else if (this.adminBatch) {
            this.adminBatch.setDoc(ctx, docRef, data);
        }
        else {
            throw ctx.newError('Invalid WebBatch');
        }
    }
    patchIn(ctx, docRef, data) {
        if (this.webBatch) {
            this.webBatch.patchIn(ctx, docRef, data);
        }
        else if (this.adminBatch) {
            this.adminBatch.patchIn(ctx, docRef, data);
        }
        else {
            throw ctx.newError('Invalid WebBatch');
        }
    }
    commit(ctx) {
        if (this.webBatch) {
            return this.webBatch.commit(ctx);
        }
        else if (this.adminBatch) {
            return this.adminBatch.commit(ctx);
        }
        else {
            throw ctx.newError('Invalid Batch');
        }
    }
}
function writeBatch(ctx, fs) {
    return new FirestoreBatch(fs._startWriteBatch(ctx));
}
class FirebaseConnection {
    constructor(firestore, user) {
        this.firestore = firestore;
        this.firestoreUser = user;
    }
    // Test case that TypeScript inference works through chains of implied classes.
    testFetchBlob(ctx, n1, n2) {
        return this.firestore.makeCollectionRef(ctx, n1).makeDocRef(n2).get().then(doc => {
            if (doc.docExists()) {
                return doc.data();
            }
            return undefined;
        });
    }
    testRunTX(ctx) {
        const doc = this.firestore.makeCollectionRef(ctx, 'foo').makeDocRef('doc');
        return transaction(ctx, this.firestore, tx => {
            return tx.getDoc(ctx, doc).then(docSnap => {
                const old = docSnap.data();
                tx.setDoc(ctx, doc, { foo: (old === null || old === void 0 ? void 0 : old.foo) || 'unset' });
            });
        });
    }
    testBatch(ctx) {
        const doc = this.firestore.makeCollectionRef(ctx, 'foo').makeDocRef('doc');
        const b = writeBatch(ctx, this.firestore);
        b.setDoc(ctx, doc, { foo: 'updated' });
        return b.commit(ctx);
    }
    testOnSnapshot(ctx) {
        const doc = this.firestore.makeCollectionRef(ctx, 'foo').makeDocRef('doc');
        const canceler = doc.onSnapshot((docSnap) => {
            ctx.log('snap', docSnap.docExists());
        }, err => {
            ctx.log('err', err.message);
        });
        return canceler;
    }
    testSimplePatchIn(ctx) {
        const doc = this.firestore.makeCollectionRef(ctx, 'foo').makeDocRef('doc');
        const patch = {
            first: 'yep',
        };
        doc.patchIn(ctx, patch);
    }
    testPatchIn(ctx) {
        const partPatch = {
            ready: false,
        };
        const doc = this.firestore.makeCollectionRef(ctx, 'foo').makeDocRef('doc');
        doc.patchIn(ctx, partPatch);
        doc.patchIn(ctx, {
            ready: true,
            secondaries: {
                anotherPlayer: true,
            },
        });
    }
}
exports.FirebaseConnection = FirebaseConnection;
function shouldRetry(err) {
    function propIncludes(e, propName, substr) {
        const val = e[propName];
        return typeof val === 'string' && val.includes(substr);
    }
    if (err && typeof err === 'object') {
        const flexErr = err;
        // firebase-admin library sees the "2: UNKNOWN " errors on updates/writes
        if ((flexErr.code === 2) && (flexErr.details === '') &&
            propIncludes(flexErr, 'note', 'transient')) {
            return 'Firestore-UNKNOWN-2 error';
        }
        // firebase-admin library sees "1 CANCELLED" errors on some GRPC race condition
        if ((flexErr.code === 1) &&
            propIncludes(flexErr, 'details', 'already cancelled') &&
            propIncludes(flexErr, 'message', '1 CANCELLED')) {
            return 'Firestore-CANCELED-1 error';
        }
        //
        //  "name": "Error",
        // "message": "Unknown listen response type: {}",
        // "stack": [ ... ]
        if ((flexErr.name === 'Error') &&
            (flexErr.message === 'Unknown listen response type: {}')) {
            return 'Firestore-unknown-listen-obj error';
        }
    }
    return undefined; // not a retryable error
}
function firestoreRetryOnErr(ctx, cb) {
    return Retry.onErr(cb, err => shouldRetry(err), {
        log: (s) => ctx.log('retry:', s),
    });
}
//# sourceMappingURL=FirebaseV9.js.map